var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attribute.src)?_c('div',[_c('a',{class:this.class,attrs:{"href":_vm.attribute.src,"target":_vm.attribute.target,"disabled":_vm.attribute.disabled},domProps:{"innerHTML":_vm._s(_vm.attribute.text)}})]):_c('div',{class:this.class,attrs:{"disabled":_vm.attribute.disabled},domProps:{"innerHTML":_vm._s(_vm.attribute.text)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea5a6e3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/IcAnsHtml/IcAnsHtml.vue
// module id = 500
// module chunks = 0